export const VIEWER_SESSION_FAILURE = {
  title: "We couldn't start the viewer",
  detail: "",
};

export const VIEWER_BUILD_FAILURE = {
  title: "The 3D viewer is unavailable",
  detail: "",
};

export const VIEWER_STARTUP_FAILURE = {
  title: "The 3D viewer couldn't start",
  summary: "The viewer is unavailable on this device.",
  detail: "",
};

export const WEBGPU_UNAVAILABLE = {
  title: "This device can't run the 3D viewer",
  summary: "The required graphics features aren't available on this device.",
  detail: "",
};

const translated = (t, key, fallback) => (typeof t === "function" ? t(key) : fallback);

export const getDashboardSessionMessage = (error, t) => {
  if (error?.code === "ACCESS_DENIED") {
    return translated(t, "viewer.error.account_access", "This account doesn't have access to this experience.");
  }

  if (error?.code === "AUTH_REQUIRED") {
    return translated(t, "viewer.error.dashboard_expired", "Your dashboard session has ended. Return to the dashboard and open this experience again.");
  }

  return translated(t, "viewer.error.dashboard_verify", "The viewer couldn't verify your dashboard session.");
};

export const getJoinFailureMessage = (error, t) => {
  const status = error?.response?.status;
  if (status === 400 || status === 404) {
    return translated(t, "viewer.error.join_unknown", "That join code wasn't recognized. Check the code and try again.");
  }
  if (status === 401 || status === 403 || status === 410) {
    return translated(t, "viewer.error.join_expired", "That join code is no longer active. Ask your teacher for a new one.");
  }
  if (status === 429) {
    return translated(t, "viewer.error.too_many_attempts", "Too many attempts were made. Wait a moment and try again.");
  }
  if (!error?.response && error?.request) {
    return translated(t, "viewer.error.network", "We couldn't reach the viewer. Check your connection and try again.");
  }
  return translated(t, "viewer.error.join_unavailable", "This experience can't be joined right now.");
};

export const getExperienceLoadMessage = (mode, error, t) => {
  if (error?.code === "STARTUP_HANDSHAKE_TIMEOUT") {
    return translated(t, "viewer.error.start_failed", "The 3D viewer couldn't start");
  }
  if (error?.code === "SESSION_HANDSHAKE_TIMEOUT") {
    return translated(t, "viewer.error.session_confirm", "The viewer could not confirm your session. Reload the page and try again.");
  }
  const status = error?.response?.status;

  if (status === 404) {
    return translated(t, "viewer.error.experience_removed", "This experience is no longer available.");
  }

  if (status === 401 || status === 403) {
    if (mode === "teacher") {
      return translated(t, "viewer.error.dashboard_expired", "Your dashboard session has ended. Return to the dashboard and open this experience again.");
    }
    if (mode === "viewer") {
      return translated(t, "viewer.error.join_session_ended", "This viewing session has ended. Open your join link again.");
    }
    return translated(t, "viewer.error.session_ended", "This viewer session has ended. Reload the page to start a new session.");
  }

  if (!error?.response && error?.request) {
    return translated(t, "viewer.error.session_network", "We couldn't reach the viewer. Check your connection and reload the page.");
  }

  return translated(t, "viewer.error.experience_unavailable", "This experience is unavailable right now.");
};
